export const environment = {
  production: false,
  region: 'ap-south-3',
  Bucket: 'ggcme',
  baseURL: 'https://dev-phenov3-api.anuvabio.io/api/v3/',
  cronURL: 'https://dev-phenov3-cron.anuvabio.io/api/v3/',

};
